export default __webpack_public_path__ + "static/media/grocery.b5d9020e.png";